import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import { type Paginate } from "@/types";

export interface Category {
  id: number;
  name: string;
  color: string;
}

export type CategoryList = Paginate<Category>;

export const categories = createQueryKeys("handbook-categories", {
  all: null,
  one: (id?: number) => [id],
});

const include = "";

export const fetchCategoriesQueryOptions = () =>
  queryOptions({
    ...categories.all,
    queryFn: () =>
      api
        .get<CategoryList>(`/handbook/entries/categories`, {
          params: { include },
        })
        .then((response) => response.data),
  });

export const useFetchCategories = () => useQuery(fetchCategoriesQueryOptions());

export const fetchCategoryQueryOptions = (id?: number) =>
  queryOptions({
    ...categories.one(id),
    queryFn: () =>
      api
        .get<Category>(`/handbook/entries/categories/${id}`)
        .then((response) => response.data),
    enabled: id !== undefined,
  });

export const useFetchCategory = (id?: number) =>
  useQuery(fetchCategoryQueryOptions(id));
